module.exports = __webpack_public_path__ + "media/images/profile_verification/thumbs_up_left-211b9dd457d9df29ab995e5530e8d9e8.png";